import React, { FC } from 'react'
import { Typography, DialogActions, Button, Box, CircularProgress } from '@mui/material'
import { StatefulDialog } from 'src/components/ui'
import { DialogNames } from 'src/enums'

interface ArchiveUserContractorModalProps {
  name: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export const ArchiveUserContractorModal: FC<ArchiveUserContractorModalProps> = ({
  name,
  onConfirm,
  onCancel,
  isLoading = false
}) => {
  return (
    <StatefulDialog
      name={DialogNames.ArchiveUserContractor}
      actions={
        <Box mb={2} mx={2}>
          <DialogActions>
            <Button variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? <CircularProgress color="info" size={26} /> : 'Archive'}
            </Button>
          </DialogActions>
        </Box>
      }
    >
      <Box minWidth="300px">
        <Typography variant="h6">Are you sure you want to archive {name}?</Typography>
      </Box>
    </StatefulDialog>
  )
}

export const UnarchiveUserContractorModal: FC<ArchiveUserContractorModalProps> = ({
  name,
  onConfirm,
  onCancel,
  isLoading = false
}) => {
  return (
    <StatefulDialog
      name={DialogNames.UnarchiveUserContractor}
      actions={
        <Box mb={2} mx={2}>
          <DialogActions>
            <Button variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? <CircularProgress color="info" size={26} /> : 'Unarchive'}
            </Button>
          </DialogActions>
        </Box>
      }
    >
      <Box minWidth="300px">
        <Typography variant="h6">Are you sure you want to unarchive {name}?</Typography>
      </Box>
    </StatefulDialog>
  )
}
